import { includes } from 'es-toolkit/compat';

export function resumeBackgroundScroll(document: Document) {
  document.body.classList.remove('Body--no-scroll');
  const scrollY = document.body.style.top;
  document.body.style.top = '';
  window.scrollTo(0, (parseInt(scrollY, 10) || 0) * -1);
}

export function disableBackgroundScroll(document: Document) {
  if (includes(document.body.classList, 'Body--no-scroll')) {
    return;
  }
  const scrollY = window.scrollY;
  document.body.classList.add('Body--no-scroll');
  document.body.style.top = `-${scrollY}px`;
}
